import { useEffect } from "react";
var useOnClickOutside = function (ref, handler) {
    useEffect(function () {
        var listener = function (event) {
            if (ref.current && event.target instanceof Node) {
                setTimeout(function () {
                    handler(event);
                }, 300);
            }
        };
        document.addEventListener("mousedown", listener);
        return function () {
            document.removeEventListener("mousedown", listener);
        };
    }, [ref, handler]);
};
export default useOnClickOutside;
//# sourceMappingURL=useOnClickOutside.js.map